


export class GameOverScene extends Phaser.Scene {

    constructor() {
        super({
            key: 'GameOverScene',
        });
    }

    public preload() {

    }

    public create() {
        this.game.destroy(true);
    }

}
